import { Box, Link, Text } from '@chakra-ui/react';
import { CreationIcon, ShareLinkIcon, tools } from '@halo/ui-chat-react';
import type { GroupInfo } from '@halo/chat-sdk-react';
import dayjs from 'dayjs';
import { InfoItem } from './InfoItem';

interface ProfileContentProps {
  group?: GroupInfo | null;
}

const ProfileContent = ({ group }: ProfileContentProps) => {
  const { t } = useTranslation();
  return (
    <Box>
      {/* <Text my="2.5" color="fg.muted" fontSize="xs" fontWeight="medium">
        Basic Information
      </Text> */}
      <Box bg="bg.panel" rounded="xl">
        <InfoItem
          icon={<ShareLinkIcon />}
          label={t('profile.shareLink')}
          extra={
            <Link
              onClick={() =>
                tools.copyToClipboard(
                  `I invited you to the group ${group?.group_name}: ${group?.share_url || ''}`
                )
              }
            >
              {group?.share_url}
            </Link>
          }
        />
        <InfoItem
          icon={<CreationIcon />}
          label={t('profile.creationDate')}
          extra={
            <Text color="fg.muted">
              {group?.created_at && dayjs(group?.created_at).format('MMMM DD, YYYY')}
            </Text>
          }
        />
      </Box>
    </Box>
  );
};

const MemoizedProfileContent = memo(ProfileContent);
export { MemoizedProfileContent as ProfileContent };
